import { useEffect, useState } from 'react';

import { useTripsRequestedCountRetrieveQuery } from '../external/bambi-api/tripsApi';
import { useFeature } from 'src/app/FeatureToggle';
import { useAppSelector } from 'src/app/store/hooks';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export const REQUESTED_TRIP_BADGE_POLLING_INTERVAL_MS = 3 * 60 * 1000;

export const useRequestedTripBadge = (poll = true) => {
  const isAddATripFormOpen = useAppSelector((state) => state.addATrip.isOpen);
  const { isRideOrderingPortalUser } = useUserRoles();
  const { isEnabled: isRequestedCountEnabled } = useFeature(
    'trip requested count'
  );
  const [showRequestedTripBadge, setShowRequestedTripBadge] = useState(false);

  const { data: requestedTrips, isLoading: isRequestedCountLoading } =
    useTripsRequestedCountRetrieveQuery(undefined, {
      skip:
        !isRequestedCountEnabled ||
        isRideOrderingPortalUser ||
        isAddATripFormOpen,
      pollingInterval: poll
        ? REQUESTED_TRIP_BADGE_POLLING_INTERVAL_MS
        : undefined,
    });

  useEffect(() => {
    if (
      !isRideOrderingPortalUser &&
      !isRequestedCountLoading &&
      requestedTrips?.count
    ) {
      setShowRequestedTripBadge(true);
    } else {
      setShowRequestedTripBadge(false);
    }
  }, [
    isRideOrderingPortalUser,
    isRequestedCountLoading,
    requestedTrips?.count,
  ]);

  return {
    showRequestedTripBadge,
    requestedTrips,
  };
};
